export default __webpack_public_path__ + "static/media/empty-cart.45936cca.png";